import {AssaySchema} from 'results/assay-schemas/AssaySchemaConstants';
import {getArchivedFields} from 'schemas/fields/SchemaFieldGetters';

import {DisplayConfig} from './AttachmentConstants';

export function makeDisplayConfig(hiddenFields: Array<string> = []): DisplayConfig {
  return {
    hideId: false,
    hideCreator: false,
    hideCreatedAt: false,
    hideReviewed: false,
    hiddenFields,
  };
}

export function makeDisplayConfigFromRunSchema(runSchema: AssaySchema): DisplayConfig {
  return makeDisplayConfig(getArchivedFields(runSchema).map((field) => field.name));
}
